export default {
  UserProfileForm: {
    label: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone Number',
      position: 'Position',
    },
    btn: {
      save: 'Save Changes',
    },
  },
};
